var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"text",staticClass:"fixed-lines",class:{ 'fixed-lines-ellipsis': _vm.useEllipsis },style:([_vm.style, _vm.ellipsisStyle])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }